import { inject, injectable } from 'inversify';
import { SockJsAdapter, Connection } from '@dealroadshow/socket-frontend-sdk';
import { ISocketAdapter } from './DI/interfaces';
import DITypes from './DI/types';
import finsightWebUrl from '@/finsight/infrastructure/finsightWebUrl';

@injectable()
export class SocketAdapter extends SockJsAdapter implements ISocketAdapter {
  constructor(
    @inject(DITypes.SocketConnection) connection: Connection,
  ) {
    super(finsightWebUrl.getSocketUrl(), connection);
  }
}
